<template>
  <div id="gameTime">
    <div>
        <headerPage :title="title" :iconSrc="iconSrc" :headerSty='headerSty'></headerPage>
        <headerBg class="headerBg" :headerBg='headerBg'></headerBg>
        <div class="txtBox">
            <div class="txt" v-if="$route.query.type=='steam' || $route.query.type=='psn'">
                今年你在游戏世界度过了<span class="txt1"  :style="colorSty">{{data.playHour}}</span><span class="txt2" :style="colorSty">h</span>
            </div>
            <div class="txt" v-else-if="$route.query.type=='epic' && !$route.query.shareRef">
                今年你在白嫖的游戏世界度过了<span class="txt1"  :style="colorSty">{{data.freeGamePlayTime | numberToCurrency(0)}}</span><span class="txt2" :style="colorSty">h</span>
            </div>
             <div class="txt" v-else-if="$route.query.type=='epic' && $route.query.shareRef">
                今年'TA'在白嫖的游戏世界度过了<span class="txt1"  :style="colorSty">{{data.freeGamePlayTime | numberToCurrency(0)}}</span><span class="txt2" :style="colorSty">h</span>
            </div>
            <div class="txt"><span>{{data.text}}</span><img src="../assets/image/steam/right_big.png"></div>
        </div>
       
        <echartPage :main="main" :timeEchartData='timeEchartData'></echartPage>
        <Title :title='data.name'></Title>
     
        <footerPage class="footerPage"></footerPage>
        <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
  </div>
</template>

<script>
import headerPage from './header.vue'
import echartPage from './echart.vue'
import footerPage from './footer.vue'
import footerBg from './footerBg.vue'
import headerBg from './headerBg.vue'
import Title from './getTitle.vue'
import { numberToCurrency } from "../assets/js/numberToCurrency";
export default {
    filters: {
        numberToCurrency
    },
    props:{
        data:{
            type:[Object]
        }
    },
    data(){
        return {
            title:'',
            main:'main1',
            iconSrc:require('../assets/image/'+this.$route.query.type+'/'+this.$route.query.type+'_small.png'),
            headerSty:{
                padding:'5.65rem 0 0 1.95rem'
            },
            footerBg:{
                background: 'url('+require('../assets/image/'+this.$route.query.type+'/xingxing.png')+')',
                backgroundSize: '42%',
                backgroundRepeat:'no-repeat',
                backgroundPosition: 'bottom right',
                // backgroundAttachment: 'fixed',

            },
            headerBg:{
                background: 'url('+require('../assets/image/'+this.$route.query.type+'/gameTimeBg.png')+')',
                backgroundSize: '100%',
                backgroundRepeat:'no-repeat',
                backgroundPosition: 'top right',
                // backgroundAttachment: 'fixed',
            },

            timeEchartData:{},
            colorSty:{},
            
        }
    },
    mounted(){
       
    
         if(this.$route.query.type=='steam'){
            this.colorSty={
                color:'#5EE6FF'
            }
             this.title='年度游戏时长'
            this.$set(this.timeEchartData,'xData',this.data.xData)
            this.$set(this.timeEchartData,'yData',this.data.yData)
        }else if(this.$route.query.type=='psn'){
            this.colorSty={
                color:'#5EA6FF'
            }
            this.title='年度游戏时长'
            this.$set(this.timeEchartData,'xData',this.data.xData)
            this.$set(this.timeEchartData,'yData',this.data.yData)
        }else if(this.$route.query.type=='xbox'){
             this.colorSty={
                color:'#5EFF97'
            }
            this.$set(this.timeEchartData,'xData',this.data.xData)
            this.$set(this.timeEchartData,'yData',this.data.yData)
        }else if(this.$route.query.type=='epic'){
            this.colorSty={
                color:'#FF5E5E'
            }
            this.title='白嫖游戏时长'
            this.$set(this.timeEchartData,'xData',this.data.freeGameTimeX)
            this.$set(this.timeEchartData,'yData',this.data.freeGameTimeY)
        }
       
      
    },
   
    methods:{
       
        getNumber(val){
            if(val){
                return val.toFixed(0)
            }
            
        }
   
    },
    components:{
        headerPage,
        echartPage,
        Title,
        footerPage,
        footerBg,
        headerBg
     
    }
}
</script>

<style>
#gameTime .txtBox{
    margin: 2rem 0 0 1.75rem;
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
#gameTime .txtBox .txt{
    margin-bottom: 1.45rem;
    line-height: 0.6rem;
}
#gameTime .txtBox .txt:nth-child(3){
    margin-bottom: 1rem;
}
#gameTime .txtBox .txt:last-child{
    margin-bottom: 2rem;
}
#gameTime .txtBox .txt1{
    font-size: 1.4rem;
    font-family: Impact;
    color: #5EE6FF;
    margin: 0 0.4rem 0 0.65rem;
}
#gameTime .txtBox .txt2{
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    color: rgba(94, 230, 255, 0.8);
}
 #gameTime .txtBox .txt:last-child{
        display: flex;
        align-items: end;
}
 #gameTime .txtBox .txt:last-child>span{
    margin-bottom: 0.25rem;
    white-space: nowrap;
 }
#gameTime .txtBox img{
    width: 1.8rem;
    height: 1.5rem;
    margin-left: 0.7rem;
    position: absolute;
    right: 0.75rem;
}
#gameTime .footerBg{
    height: 11rem;
}
</style>